<template>
  <div class="dwp-space-y-6 dwp-flex dwp-flex-col">
    <div class="dwp-flex dwp-justify-between dwp-items-center dwp-px-10 dwp-pt-10">
      <ArrowLeftIcon
        @click="tab = null"
        class="dwp-text-gray-500 dwp-w-6 dwp-h-6 dwp-cursor-pointer dwp-flex-shrink-0 dwp-mr-3"
      />
      <div
        class="sm:dwp-text-xl dwp-text-xl dwp-leading-none dwp-text-gray-700 dwp-font-medium dwp-flex dwp-items-baseline dwp-overflow-hidden"
      >
        <span class="dwp-truncate dwp-flex-1">{{ currentList && currentList.title }}</span>
        <span class="dwp-flex-shrink-0">&nbsp;Trashed Tasks</span>
      </div>
      <div class="dwp-w-6 dwp-h-6"></div>
    </div>
    <div
      v-loading="loading"
      class="dwp-overflow-auto dwp-px-10 dwp-flex-1 dwp-pb-10 dwp-text-gray-800"
    >
      <Flash
        type="warning"
        class="dwp-text-xs dwp-mb-6"
      >These tasks will be permanently deleted after 30 days.</Flash>

      <template v-if="Object.keys(trashed).length">
        <div
          v-for="task in trashed"
          :key="task.id"
          class="dwp-rounded dwp-relative dwp-group dwp-text-base dwp-select-none"
          data-cy="task"
        >
          <div
            class="dwp-flex dwp-justify-between dwp-items-start dwp-border-t dwp-border-gray-200 dwp-py-3"
          >
            <TaskTemplate>
              <template #checkbox>
                <Checkbox data-cy="toggle-done" class="dwp-cursor-pointer" />
              </template>
              <template #title>
                <div
                  class="dwp-space-x-2 dwp-drag-handle dwp-cursor-pointer"
                  data-cy="toggle-notes"
                >
                  <div
                    class="dwp-inline"
                    data-cy="task-title"
                    :class="task.done ? 'dwp-line-through' : ''"
                  >
                    <slot>{{ task.title }}</slot>
                  </div>
                </div>
              </template>
              <template #content>
                <div
                  class="dwp-text-xs dwp-cursor-pointer dwp-text-gray-500"
                >Will be deleted in {{ task.modified | difference }} days.</div>
              </template>
            </TaskTemplate>

            <div class="dwp-flex dwp-items-center dwp-opacity-0 group-hover:dwp-opacity-100">
              <div
                class="dwp-tooltip-wrap dwp-p-1 dwp-cursor-pointer"
                @click="restore(task)"
                data-cy="restore-task"
              >
                <RefreshCcwIcon class="dwp-w-3 dwp-h-3 dwp-text-gray-500" />
                <p class="dwp-tooltip">Un-Trash</p>
              </div>
              <div
                class="dwp-tooltip-wrap dwp-p-1 dwp-cursor-pointer"
                @click="forceDelete(task)"
                data-cy="delete-task"
              >
                <TrashIcon class="dwp-w-3 dwp-h-3 dwp-text-red-500" />
                <p class="dwp-tooltip">Delete</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        class="dwp-text-base dwp-justify-center dwp-px-8 dwp-py-2 dwp-flex dwp-text-gray-500 dwp-items-center dwp-truncate dwp-rounded-r-full dwp-mr-6 dwp-space-x-2"
      >This list has no trashed tasks.</div>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon, RefreshCcwIcon, TrashIcon } from "vue-feather-icons";
import { sync, get } from "vuex-pathify";
import Task from "@/components/task/Task.vue";
import currentList from "@/mixins/current-list";
import TaskTemplate from "@/components/templates/TaskTemplate.vue";
import Checkbox from "@/components/Checkbox.vue";
import Flash from "@/components/ui/Flash.vue";
import { differenceInDays } from "date-fns";
import { Firebase } from "@/services/firebase";

export default {
  filters: {
    difference(val) {
      return (
        differenceInDays(
          val,
          Firebase.firestore.Timestamp.now().toMillis() - 2592000000
        ) + 1
      );
    },
  },

  mixins: [currentList],

  components: {
    ArrowLeftIcon,
    TaskTemplate,
    RefreshCcwIcon,
    TrashIcon,
    Flash,
    Checkbox,
    Task,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    tab: sync("ui/main@tab"),
    tasks: get("tasks/items"),
    trashed() {
      return this.filterObject(this.tasks || {}, (task) => {
        return task.status == "trashed" && task.list_id == this.currentList.id;
      });
    },
  },

  // add archived to realtime updates
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("tasks/bindTrashed", this.currentList);
    this.loading = false;
  },

  // return to normal
  async beforeDestroy() {
    await this.$store.dispatch("tasks/bindTasks", true);
  },

  methods: {
    restore(task) {
      this.$store.dispatch("tasks/rePublish", task);
    },

    forceDelete(task) {
      let r = confirm("Permanently delete the task? There is no undo.");
      if (r) {
        this.$store.dispatch("tasks/delete", task.id);
      }
    },
  },
};
</script>